export var Header;
(function (Header) {
    Header["NAVIGATION_ID"] = "X-OVH-MANAGER-NAVIGATION-ID";
    Header["REQUEST_ID"] = "X-OVH-MANAGER-REQUEST-ID";
    Header["PAGE"] = "X-OVH-MANAGER-PAGE";
    Header["VERSION"] = "X-OVH-MANAGER-VERSION";
})(Header || (Header = {}));
export const ROUTES_PREFIX = ['/engine/apiv6', '/engine/2api', '/engine/api/v2'];
export const DEFAULT_ROUTES_HEADERS_OVERRIDE = {};
let currentPage = 'bootstrap';
const headersOverride = DEFAULT_ROUTES_HEADERS_OVERRIDE;
export const generateNavigationId = () => {
    if (window.top) {
        window.top.ovhRequestTaggerNavigationId = Date.now().toString(36);
        return window.top.ovhRequestTaggerNavigationId;
    }
    const fallbackId = Date.now().toString(36);
    window.ovhRequestTaggerNavigationId = fallbackId;
    return fallbackId;
};
export const getNavigationId = () => {
    if (!window?.top?.ovhRequestTaggerNavigationId)
        return generateNavigationId();
    return window.top.ovhRequestTaggerNavigationId;
};
export const defineApplicationVersion = (version) => {
    window.ovhRequestTaggerApplicationVersion = version;
};
export const getApplicationVersion = () => window?.ovhRequestTaggerApplicationVersion;
export const generateRequestId = () => {
    if (window.top) {
        window.top.ovhRequestTaggerRequestIndex = window.top.ovhRequestTaggerRequestIndex ?? 0;
        window.top.ovhRequestTaggerRequestIndex += 1;
        return `${Date.now()}-${window.top.ovhRequestTaggerRequestIndex}`;
    }
    window.ovhRequestTaggerRequestIndex = (window.ovhRequestTaggerRequestIndex ?? 0) + 1;
    return `${Date.now()}-${window.ovhRequestTaggerRequestIndex}`;
};
export const defineCurrentPage = (page) => {
    currentPage = page;
};
export const addHeadersOverride = (pattern, headers) => {
    headersOverride[pattern] = headers;
    return headersOverride;
};
export const removeHeadersOverride = (pattern) => {
    delete headersOverride[pattern];
    return headersOverride;
};
export const getHeadersOverride = () => headersOverride;
export const isURLValid = (url) => {
    return ROUTES_PREFIX.some((prefix) => url?.startsWith(prefix));
};
export const searchHeadersOverride = (url) => {
    const overridesKey = Object.keys(headersOverride).find((routePattern) => new RegExp(routePattern).test(url));
    if (overridesKey) {
        return headersOverride[overridesKey];
    }
    return undefined;
};
export const getHeaders = (url) => {
    if (isURLValid(url)) {
        return {
            [Header.NAVIGATION_ID]: getNavigationId(),
            [Header.REQUEST_ID]: generateRequestId(),
            [Header.PAGE]: currentPage,
            ...(window.ovhRequestTaggerApplicationVersion
                ? { [Header.VERSION]: window.ovhRequestTaggerApplicationVersion }
                : {}),
            ...searchHeadersOverride(url),
        };
    }
    return {};
};
